import React from "react"
import styled from "styled-components"
import "react-toastify/dist/ReactToastify.css"
import { 
    FaPlus, 
    FaFolder,
    FaHeart,
    FaComment,
    FaInfo,
} from "react-icons/fa"
import { FaRadio } from "react-icons/fa6"
import ButtonWithIconOnTop from "./buttons/ButtonWithIconOnTop.js"
import { MELOGY_TRANSPARENT,} from "../style/colors.js"

const ControlsBackgroundColor = styled.div`
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: ${MELOGY_TRANSPARENT}; 
    z-index: 2;
`

const ControlsContainer = styled.div`
    width: 100%;
    max-width: 960px;
    display: flex;
    justify-content: center;
    align-items: center;
`

const ControlsBackground = styled.div`
    height: 100%;
    width: 80%;
    display: flex;
    justify-content: space-evenly;
`

const HistoryAndDownloadContainer = styled.div`
    height: 48px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
`


const Controls = ({
    createAndFetchMidi,
    toggleLeftSideBar,
    midi,
    showCreateButton = true,
    toggleAutoPlay,
    isAutoPlayEnabled,
    toggleAboutPopover,
    toggleDonatePopover,
    toggleContactPopover,
}) => {
    return (
        <>
            {midi && (
                <ControlsBackgroundColor>
                    <ControlsContainer>
                        <ControlsBackground>
                            <HistoryAndDownloadContainer>
                                <ButtonWithIconOnTop
                                    text="About"
                                    buttonColor="white"
                                    onClick={toggleAboutPopover}
                                    icon={<FaInfo style={{ fontSize: "16px" }} />}
                                    width="64px"
                                    background="linear-gradient(180deg, rgba(249, 98, 249, 1) 12%, rgba(98, 249, 249, 1) 100%)"
                                />
                                <ButtonWithIconOnTop
                                    text="Donate"
                                    buttonColor="white"
                                    onClick={toggleDonatePopover}
                                    icon={<FaHeart style={{ fontSize: "16px" }} />}
                                    width="64px"
                                    background="linear-gradient(180deg, rgba(249, 98, 249, 1) 12%, rgba(98, 249, 249, 1) 100%)"
                                />
                                <ButtonWithIconOnTop
                                    text="Contact"
                                    buttonColor="white"
                                    onClick={toggleContactPopover}
                                    icon={<FaComment style={{ fontSize: "16px" }} />}
                                    width="64px"
                                    background="linear-gradient(180deg, rgba(249, 98, 249, 1) 12%, rgba(98, 249, 249, 1) 100%)"
                                />
                                {showCreateButton && (
                                    <ButtonWithIconOnTop
                                        text="Create"
                                        buttonColor="white"
                                        onClick={createAndFetchMidi}
                                        icon={
                                            <FaPlus style={{ fontSize: "16px" }} />
                                        }
                                        width="64px"
                                        background="linear-gradient(177deg, rgba(249, 98, 249, 1) 2%, rgba(98, 249, 249, 1) 100%)"
                                    />
                                )}
                                <ButtonWithIconOnTop
                                    text="Radio"
                                    buttonColor="white"
                                    onClick={toggleAutoPlay}
                                    icon={<FaRadio style={{ fontSize: "16px" }} />}
                                    width="64px"
                                    background="linear-gradient(180deg, rgba(249, 98, 249, 1) 12%, rgba(98, 249, 249, 1) 100%)"
                                    isSelected={isAutoPlayEnabled}
                                />
                            </HistoryAndDownloadContainer>
                        </ControlsBackground>
                    </ControlsContainer>
                </ControlsBackgroundColor>
            )}
        </>
    )
}

export default Controls
